
export default {
  name: 'Breadcrumb',
  props: {
    breadcrumb_list: Array,
    scrollToEnd: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      referrer: null,
    }
  },
  watch: {
    breadcrumb_list() {
      this.scrollToEndOfBreadcrumb()
    },
  },

  created() {
    this.scrollToEndOfBreadcrumb()
  },
  methods: {
    scrollToEndOfBreadcrumb() {
      if (process.client && this.$device.isMobile && this.scrollToEnd) {
        setTimeout(() => {
          let bredcrumb = document.getElementsByClassName('breadcrumb')
          bredcrumb[1]
            ? (bredcrumb[1].scrollLeft = bredcrumb[1].scrollWidth)
            : null
        }, 600)
      }
    },
    goBack() {
      window.history.back()
    },
  },
}
